enum CommentStatus {
  READED = 'READED',
  CREATED = 'CREATED',
}

export { CommentStatus };
